// src/pages/Home.js
import React from 'react';
import AdopcionEnviada from '../AdopcionEnviadaComponents/AdopcionEnviada';
function Home() {
  return (
    <div>
      <AdopcionEnviada/>
    </div>
  );
}

export default Home;